import { authGuard } from './core/guard/auth.guard';
import { PageLayoutComponent } from './layout/page-layout/page-layout.component';
import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('../app/modules/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: ':tenantcode',
    component: PageLayoutComponent, // shell layout
    canActivate: [authGuard],
    children: [
      // {
      //   path: 'dashboard',
      //   loadChildren: () =>
      //     import('./modules/dashboard/dashboard.module').then(
      //       (m) => m.DashboardModule
      //     ),
      // },
      {
        path: 'insights',
        loadChildren: () =>
          import('./modules/insights/insights.module').then(
            (m) => m.InsightsModule
          ),
      },
      {
        path: 'workbench',
        loadChildren: () =>
          import('./modules/workbench/workbench.module').then(
            (m) => m.WorkbenchModule
          ),
      },
      // Add more feature routes here
    ],
  },
  { path: '**', redirectTo: '/' },
];
